import moment from 'moment';
import _ from 'lodash';
import regex from '../../../../constants/regExps';
import { maxWorkingHoursValue, minJobHoursValue } from '../../../../constants/jobs';

// Custom default rules to validate form fields
export default {
  numbers: regex.numbers,
  requiredIdField: regex.integerGreaterThanZero,
  email: regex.email,
  password: regex.password,
  isUrl: regex.url,
  required (isActivated, value) {
    let isValid = !_.isEmpty(value) || (_.isNumber(value) && value !== 0) || _.isBoolean(value);

    if (typeof value === 'string') {
      isValid = regex.emptyString.test(value);
    }

    return isValid;
  },
  date (format = 'YYYY-MM-DD', value) {
    const d = moment(value, format);
    return !(d == null || !d.isValid());
  },
  minLength (minLength, value) {
    return value.length >= minLength;
  },
  maxLength (maxLength, value) {
    return value.length <= maxLength;
  },
  length (length, value) {
    return value.length === length;
  },
  zipcode: regex.zipcode,
  cvc: regex.cvc,
  minJobHours (isActivated, value) {
    return value >= minJobHoursValue;
  },
  maxJobHours (isActivated, value) {
    return value <= maxWorkingHoursValue;
  },
  requiredCheckbox (isActivated, value) {
    return value === true;
  },
  maxValue (maxValue, value) {
    return value <= maxValue;
  },
  minValue (minValue, value) {
    return value >= minValue;
  }
};



// WEBPACK FOOTER //
// ./src/components/common/forms/Validator/defaultRules.js